export const BLOCKED_VALUE_MODAL_PT_BR = {
	title: "Valor Bloqueado",
	description: "O que são os valores bloqueados?",
	descriptionText: [
		"Valores bloqueados são montantes temporariamente indisponíveis",
		"devido a políticas de segurança ou processamento de transações.",
	].join(" "),
	totalSummary: "Somatória total",
	liquidationDate: "DATA DE LIQUIDAÇÃO",
	competenceDate: "DATA DE COMPETÊNCIA",
	type: "TIPO",
	category: "CATEGORIA",
	observation: "OBSERVAÇÃO",
	value: "VALOR",
	blockTypes: {
		"Bloqueio automático": "Bloqueio automático",
		"Bloqueio manual": "Bloqueio manual",
		"Cessão de recebíveis": "Cessão de recebíveis",
	},
	blockCategories: {
		"Transferência de titularidade": "Transferência de titularidade",
		"Ônus - Cessão fiduciária": "Ônus - Cessão fiduciária",
		"Ônus - Outros": "Ônus - Outros",
		"Bloqueio judicial": "Bloqueio judicial",
		"Promessa de Cessão": "Promessa de Cessão",
		"Tipo desconhecido": "Tipo desconhecido",
	},
	blockObservationPrefixes: {
		"CNPJ do solicitante:": "CNPJ do solicitante:",
	},
};

export type BlockedValueModalTranslations = typeof BLOCKED_VALUE_MODAL_PT_BR;
